import './style.scss';

/**
 * コンテンツのAjax読み込みを行うクラス
 */
class LoadContents{
    constructor(params){
        this.settings = {
            ...this.defaults(),
            ...params,
        }
        this.init();
    }

    defaults(){
        return {
            targetSelector: '.js-load-contents'
        }
    }

    init(){
        let loadObjs = [];
        document.querySelectorAll(this.settings.targetSelector).forEach((obj) => {
            loadObjs.push(obj);
        });

        Promise.all(loadObjs.map(async (obj) => {
            this.showLoading(obj);
            const content = await this.loadContents(obj);
            this.setContents(content, obj);
            this.hideLoading(obj);
        }));
    }

    showLoading(targetObj){
        targetObj.classList.add('is-loading');
        const loader = document.createElement('div');
        loader.className = 'load-contents-loader';
        loader.innerHTML = '<div class="load-contents-spinner"></div>';
        targetObj.appendChild(loader);
    }

    hideLoading(targetObj){
        targetObj.classList.remove('is-loading');
        const loader = targetObj.querySelector('.load-contents-loader');
        if (loader) {
            loader.remove();
        }
    }

    async loadContents(obj){
        const endpoint = obj.dataset.endpoint;
        const targetSelector = obj.hasAttribute('data-target') ? obj.dataset.target : 'body';
        const content = await fetch(endpoint)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(data => {
                const parser = new DOMParser();
                const dom = parser.parseFromString(data, "text/html");
                return dom.querySelector(targetSelector);
            })
            .catch(error => {
                console.error('There has been a problem with your fetch operation:', error);
            });
        return content;
    }

    setContents(content, targetObj){
        targetObj.innerHTML = content.innerHTML;
        targetObj.dispatchEvent(new Event('onLoadContents'));
    }
}

export default LoadContents;
